module.exports = __webpack_public_path__ + "static/media/step5.79a21526.png";